module.exports = __webpack_public_path__ + "img/md-cart.40fe4e3a.svg";